import { render, staticRenderFns } from "./OffcanvasMenu.vue?vue&type=template&id=dc61aae8"
import script from "./OffcanvasMenu.vue?vue&type=script&lang=ts"
export * from "./OffcanvasMenu.vue?vue&type=script&lang=ts"
import style0 from "./OffcanvasMenu.vue?vue&type=style&index=0&id=dc61aae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports